// extracted by mini-css-extract-plugin
export default {"th-td":"CertificationsTable_th-td__riOoo"};